import { findMany, whenElementIsInView, addClass, removeClass } from '../helpers';

// Find all elements with the '[data-timeline]' attribute
const timelineBlocks = findMany('[data-timeline]');

// Define the CSS class name used to indicate an active element
const activeClass = 'is-active';

// Initialize a variable to track the active timeline block
let activeBlock = null;

// Iterate through each timeline block
timelineBlocks.forEach(item => {
    // Options for whenElementIsInView function
    const options = { margin: '-50%' };

    // Execute code within the next animation frame
    requestAnimationFrame(() => {
        // Detect when the current timeline block comes into view
        whenElementIsInView(item, inView => {
            if (inView) {
                // Deactivate the previous active block, if any
                if (activeBlock !== item) {
                    removeClass(activeBlock, activeClass);
                }

                // Activate the current block
                addClass(item, activeClass);
                activeBlock = item;
            } else {
                // Deactivate the current block when it goes out of view
                removeClass(item, activeClass);

                // Reset the activeBlock reference
                if (activeBlock === item) {
                    activeBlock = null;
                }
            }
        }, false, options);
    });
});
